import React, { useState } from 'react'
import { FaGithub, FaRegFileAlt } from 'react-icons/fa'
import { FcGoogle } from 'react-icons/fc'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import signupImg from '../assets/signup.svg'
import { supabase } from '../lib/util'
import { useForm } from 'react-hook-form'
import { FaEye, FaEyeSlash } from 'react-icons/fa6';




const Signup = () => {
    const [formData, setFormData] = useState({
        email: '',
        password: ''
    })
    const { register, handleSubmit, formState: { errors } } = useForm();

    const navigate = useNavigate();
    const location = useLocation();
    const fromPreviewLayout = location?.state?.fromPreviewLayout;
    const [showPassword, setShowPassword] = useState(false);

    // Function to toggle password visibility
    const togglePasswordVisibility = () => {
        setShowPassword((prevState) => !prevState);
    };




    async function signUpNewUser(e) {
        // e.preventDefault()
        const { email = '', password = '' } = formData



        try {
            const { data: userData } = await supabase
                .from('UserData')
                .select("email")
                .eq("email", email)
                .single();


            if (userData) {
                throw new Error("This email has already been registered. Please use a different email address.");
            }


            const { data, error } = await supabase.auth.signUp({
                email: email,
                password: password,
                options: {
                    emailRedirectTo: domainUrl,

                },
            })

            if (data) {

                navigate("/signin", {
                    state: {
                        fromSignUp: true
                    }
                })
            }

            if (error) throw error

            const { error: insertError } = await supabase
                .from("UserData")
                .insert([{ email }]);
            if (insertError) throw insertError;


        } catch (error) {
            toast(error.message)
        }
    }

    const handleOnChange = (e) => {
        setFormData({
            ...formData,
            [e.target.name]: e.target.value
        })
    }

    let domainUrl = process.env.REACT_APP_DOMAIN_URL;
    if(fromPreviewLayout){
        domainUrl += '/resume-builder'
    } else{
        domainUrl += '/'
    }
    const handleAuthLogin = async (provider) => {

         await supabase.auth.signInWithOAuth({
            provider: provider,
            options: {
                queryParams: {
                    access_type: "offline",
                    prompt: "consent",
                },
                redirectTo: domainUrl
            }
        })




    }






    return (
        <div className='w-full flex h-full'>

            <div className='md:w-1/2 flex flex-col justify-center h-screen max-w-xs md:max-w-md  mx-auto'>
                <div className='md:hidden absolute inset-4 z-20 pointer-events-none text-sky-600'>
                    <Link to='/' className='flex items-center'>
                        <div className='text-lg mx-1'>
                            <FaRegFileAlt />

                        </div>
                        <h1 className='text-lg font-semibold'>ResumeCraftr</h1>
                    </Link>
                </div>
                <h1 className={`text-center ${fromPreviewLayout ? 'text-xl' : 'text-3xl'} pb-1 font-semibold`}>{fromPreviewLayout ? "Create an Account to Download Your Resume" : "Create your account"}</h1>
                <h2 className='text-gray-400 text-sm md:text-base text-center pb-4'> Start building your professional resume today</h2>
                <div className='flex flex-col justify-between'>
                    <button onClick={() => handleAuthLogin("google")} className='flex items-center justify-center border my-2 rounded-sm border-black/30 px-14 md:px-24 py-2'><FcGoogle className='text-lg mt-1' /> <span className='mx-2 text-sm md:text-base font-semibold'>Continue with Google</span></button>
                    <button onClick={() => handleAuthLogin("github")} className='flex items-center justify-center border my-2 rounded-sm border-black/30 px-14 md:px-24 py-2'><FaGithub className='text-lg mt-1' /> <span className='mx-2 text-sm md:text-base font-semibold'>Continue with Github</span></button>
                </div>
                <div className="relative mt-4">
                    <div className="absolute inset-0 flex items-center">
                        <span className="w-full border-t"></span>
                    </div>
                    <div className="relative flex justify-center text-sm">
                        <span className="px-2 bg-white text-gray-700">
                            Or continue with email
                        </span>
                    </div>
                </div>
                <form onSubmit={handleSubmit(signUpNewUser)} className='flex flex-col mt-4'>
                    {/* <label htmlFor="" className='mt-3 text-lg'>Full Name</label>
                    <input type="text" placeholder='John Doe' className='border px-3 py-2 my-2' /> */}

                    <label htmlFor="" className='mt-3 text-lg'>Email</label>
                    <input type="email" placeholder='Enter your email' className='border px-3 py-2 my-2'
                        {...register('email', {
                            value: formData?.email,
                            required: true,
                            pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                            onChange: (e) => handleOnChange(e)
                        })} />
                    {errors.email && <p className="text-red-500 text-xs italic">Please enter a valid email address</p>}

                    <label htmlFor="" className='mt-3 text-lg'>Password</label>
                    <div className='relative my-2 flex items-center'>
                        <input type={showPassword ? "text" : "password"} placeholder='Enter your password' className='relative w-full border px-3 py-2 '
                            {...register('password', {

                                value: formData?.password,
                                required: true,
                                minLength: 8,
                                pattern: /^(?=.*[A-Za-z])(?=.*\d).{6,}$/,
                                onChange: (e) => handleOnChange(e),


                            })} />

                        <div className='absolute right-3 text-lg cursor-pointer' onClick={togglePasswordVisibility}>
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                        </div>
                    </div>

                    {
                        errors.password && (
                            <p className="text-red-500 text-xs italic">
                                Password must be at least 6 characters long and include at least one letter and one number.
                            </p>
                        )}
                    {/* <div className="flex items-center justify-between my-4">
                        <div className="flex items-center space-x-2 ">
                            <input type='checkbox' checked id="remember" />
                            <label
                                htmlFor="remember"
                                className="text-sm text-gray-500 leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                            >
                                Remember me
                            </label>
                        </div>
                        <Link
                            href="/forgot-password"
                            className="text-sm text-sky-600 hover:text-sky-500"
                        >
                            Forgot password?
                        </Link>
                    </div> */}
                    <button type='submit'
                        className="w-full h-12 rounded bg-black hover:bg-gray-700 text-white mt-4"
                    >
                        Create Account
                    </button>
                </form>
                <p className="text-center text-gray-600 mt-6">
                    Already have an account?{" "}
                    <Link to="/signin" className="text-sky-600 hover:text-sky-500 font-medium">
                        Sign in
                    </Link>
                </p>
                {/* <div className='text-center mt-2 flex items-center w-full mx-auto'> <div className='h-1 bg-black w-full'></div> <span className='w-1/2'>Or use e-mail address</span> <div className='h-1 bg-black w-full'></div></div> */}
            </div>
            <div className='relative hidden md:flex items-center flex-col justify-center w-1/2 h-screen bg-gradient-to-b from-blue-500 to-blue-600'>
                <div className='text-white absolute inset-5'>
                    <Link to='/' className='flex items-center'>
                        <div className='text-xl mx-1'>
                            <FaRegFileAlt />

                        </div>
                        <h1 className='text-xl font-semibold'>ResumeCraftr</h1>
                    </Link>
                </div>


                {/* <div className=' mx-auto text-white text-xl'>ResumeCraftr</div> */}
                <h1 className='text-white text-4xl font-semibold'>Join the Resume Revolution!</h1>
                <h2 className='text-white/80'>{fromPreviewLayout ? "Your personalized resume is ready! Sign up now to access, edit, and download it anytime." : "Create stunning, professional resumes in minutes. Sign up now and land your dream job!"}</h2>
                <img src={signupImg} alt="" className='h-64 mt-5' />

            </div>
            <ToastContainer />
        </div>
    )
}

export default Signup